module.exports = __webpack_public_path__ + "static/media/Heraldo-de-Aragon.71bf04a8.webp";